<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
<router-outlet></router-outlet>

<div class="global-loader" *ngIf="spinnerService.loading$ | async">
  <div class="global-loader__backdrop"></div>
  <div class="global-loader__content">
    <p-progressSpinner
      strokeWidth="4"
      fill="transparent"
      animationDuration=".8s"
      ariaLabel="Loading">
    </p-progressSpinner>
  </div>
</div>
